// extracted by mini-css-extract-plugin
export default {"backButton":"RegisterPage_backButton__sNB7Q","tosLabel":"RegisterPage_tosLabel__Je-k-"};